/* eslint react/prop-types:0 */
import React from 'react';

import { LoadablePaint } from '@confluence/loadable';
import { Screen } from '@confluence/screen';
import { MainLayout } from '@confluence/main-layout';

const PdfExportPageRouteComponent = LoadablePaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-PdfExportPageRouteComponent" */ './PdfExportPageRouteComponent'
		),
});

export const PdfExportPageRoute = ({ name, params: { contentId, spaceKey } }) => (
	<Screen
		pageState={{
			contentId,
			routeName: name,
			spaceKey,
		}}
		screenEvent={{ name: 'pdfExportScreen' }}
	>
		<MainLayout enableNavigation={false} spaceKey={spaceKey}>
			<PdfExportPageRouteComponent contentId={contentId} spaceKey={spaceKey} />
		</MainLayout>
	</Screen>
);
